import type { SelectedFilters } from '../entities/filters';

type SingleProperty<T extends {}> = {
  [K in keyof T]: { [P in K]-?: NonNullable<T[P]> };
}[keyof T];

export function getDeepestSelectedFilters({
  arrayId,
  nodeId,
  containerId,
  bankId,
  packId,
  moduleId,
}: SelectedFilters): SingleProperty<SelectedFilters> | {} {
  if (moduleId) {
    return { moduleId };
  } else if (packId) {
    return { packId };
  } else if (bankId) {
    return { bankId };
  } else if (containerId) {
    return { containerId };
  } else if (nodeId) {
    return { nodeId };
  } else if (arrayId) {
    return { arrayId };
  } else {
    return {};
  }
}
